import { Component } from '@angular/core';
import { ModalController, AlertController } from 'ionic-angular';
import { HttpClient } from '../../../services/HttpClient';

import { AddFilePage } from '../../../util/addFile/addFile';
import { CustomToast } from '../../../util/CustomToast';
import { CustomAlert } from '../../../util/CustomAlert';

@Component({
  selector: 'page-files',
  templateUrl: 'files.html',
  providers : [HttpClient, CustomToast, CustomAlert]
})
export class FilesPage {

	files;
  searchQuery = '';
  images;

  modalCtrl : ModalController;
	
  httpClient : HttpClient;
  baseUrl;
  
  customToast : CustomToast;
  customAlert : CustomAlert;

  	constructor(private alertController : AlertController, httpClient : HttpClient,modalCtrl : ModalController, customToast : CustomToast, customAlert : CustomAlert) {
  		this.modalCtrl = modalCtrl;
      this.httpClient = httpClient;
      this.baseUrl = this.httpClient.getBaseUrl();
      this.customToast = customToast;
      this.customAlert = customAlert;
      this.httpCallImages('');
  	}

    httpCallImages(name){
      this.httpClient.get('/files?name='+name,(error,data)=>{
        this.images = data.json();
      });
    }

    httpCallDeleteImage(image){
      this.httpClient.delete('/files/'+image.id, (error,data)=>{
        if(!error){
          this.customToast.showMessage('Imagen eliminada correctamente',2000);
          this.httpCallImages('');
        }else{
          this.customToast.showMessage('No se ha podido eliminar la imagen',2000);
        }
      });
    }

    onSearch(){
      if(this.searchQuery.length > 0){
        this.httpCallImages(this.searchQuery);
      }else{
        this.httpCallImages(this.searchQuery);
      }
    }

    onClickAdd(){
      let modal = this.modalCtrl.create(AddFilePage);
      modal.onDidDismiss(reload=>{
        if(reload){
          this.customToast.showMessage('Imagen añadida correctamente',2000);
          this.httpCallImages('');
        }
      });
      modal.present();
    }

    onClickDelete(image){
      this.customAlert.showPromptAlert('Vas a eliminar esta imagen','¿Estás seguro?', (isOk)=>{
        if(isOk){
          this.httpCallDeleteImage(image);
        }
      });
    }

    onClickTags(image){
      this.alertController.create({
        title : 'Vas a modificar los tags',
        message : 'Al pulsar guardar modificarás los tags de esta imagen',
        inputs : [{
          name : 'tags',
          placeholder : 'Añadir tags',
          value : image.tags,
          type : 'textarea'
        }],
        buttons : [{
          role : 'cancel',
          text : 'Cancelar'
        },{
          text : 'Guardar',
          handler : data => {
            this.putImageTags(image,data.tags);
          }
        }]
      }).present();
    }

    private putImageTags(image,tags){
      image.tags = tags;
      this.httpClient.put('/files/'+image.id,image,()=>{
        this.customToast.showMessage('Tags modificados correctamente',3000);
        this.httpCallImages('');
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/files/files.ts